import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import all translation files
import en from '../locales/en.json';
import es from '../locales/es.json';
import fr from '../locales/fr.json';
import ar from '../locales/ar.json';
import zh from '../locales/zh.json';
import ru from '../locales/ru.json';
import it from '../locales/it.json';
import hi from '../locales/hi.json';
import sw from '../locales/sw.json';
import pt from '../locales/pt.json';

export const SUPPORTED_LANGUAGES = [
    { code: 'en', name: 'English', flag: '🇺🇸', dir: 'ltr' },
    { code: 'es', name: 'Español', flag: '🇪🇸', dir: 'ltr' },
    { code: 'fr', name: 'Français', flag: '🇫🇷', dir: 'ltr' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦', dir: 'rtl' },
    { code: 'zh', name: '中文', flag: '🇨🇳', dir: 'ltr' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺', dir: 'ltr' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹', dir: 'ltr' },
    { code: 'hi', name: 'हिन्दी', flag: '🇮🇳', dir: 'ltr' },
    { code: 'sw', name: 'Kiswahili', flag: '🇰🇪', dir: 'ltr' },
    { code: 'pt', name: 'Português', flag: '🇧🇷', dir: 'ltr' },
] as const;

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number]['code'];

const resources = {
    en: { translation: en },
    es: { translation: es },
    fr: { translation: fr },
    ar: { translation: ar },
    zh: { translation: zh },
    ru: { translation: ru },
    it: { translation: it },
    hi: { translation: hi },
    sw: { translation: sw },
    pt: { translation: pt },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: localStorage.getItem('flashusdt:language') || 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
    });

export default i18n;

/**
 * Get language info by code
 */
export function getLanguageInfo(code: string) {
    return SUPPORTED_LANGUAGES.find(lang => lang.code === code) || SUPPORTED_LANGUAGES[0];
}

/**
 * Check if language is RTL
 */
export function isRTL(code: string): boolean {
    const lang = getLanguageInfo(code);
    return lang.dir === 'rtl';
}
